module.exports = __webpack_public_path__ + "static/media/fractalVerse.636f2a92.png";